var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-editor-container"},[_c('panel-group'),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('operateProcess')],1)],1),_c('el-row',[_c('plat')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }